//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import infinite from "../../directives/infinite";
  export default {
      name: "home",
      components:{},
      directives:{infinite},
      data() {return {
        summary:[
          {count:7,unit:'项',title:'年度已组织工作'},
          {count:896,unit:'人次',title:'年度已通过评选'},
          {count:15,unit:'项',title:'历年已组织工作'},
          {count:2366,unit:'人次',title:'历年已通过评选'},
        ],
        options:[
          {label:'全部',value:null}
        ],
        moreBtnList:[
          {title:'自评学校工作',description:'查看自评校工作情况',icon:'zp-icon',url:''},
          {title:'自评学校列表',description:'查看辖区内自评学校列表',icon:'zpxx-icon',url:''},
          {title:'教师评审查询',description:'查看某位教师参与过的职称评审工作',icon:'jscx-icon',url:''},
          {title:'下级工作监督',description:'查看下级开展的评审工作情况',icon:'xjjd-icon',url:''},
          {title:'人社账号管理',description:'对人社账号进行管理',icon:'rszh-icon',url:'HSAccount'},
        ],
        planList:{},
        tableList:[],
        total:{},
        currentPage:{},
        search:{},
        canGetMore:true,
        loadingData:false,
        scrollTop:{},
        //tag名称
        tagNames:['self','sub','sup','active','apply','applying'],
        tagTitles:{'self':'自评评审','sub':'本级评审','sup':'上级评审','active':'进行中的评审','apply':'全部申报','applying':'进行中的申报'},
        levels:{'self':null,'sub':null,'sup':1,'active':4,'apply':2,'applying':4},
        //当前显示的tag
        showingTagNames:[],
        //当前活跃的tag
        currentTagName:null,
        searchData:{},
        $level:null,
        userInfo:null,
        tabSummary:{},
        mainRouteName:'',
      }},
    computed:{
      isTeacher(){return this.$store.getters.isTeacher}
    },
      mounted(){
        console.log(this.$store);
        setTimeout(()=>this.initList(),100)
        this.userInfo=this.$store.state.user.UserInfo
        this.mainRouteName=this.$route.name.split('.')[0]
        switch (this.userInfo.LEVEL){
          case 2:
            this.showingTagNames=['active','sub']
            this.tagTitles.sub='全部评审'
            break
          case 16:case 128:
            this.showingTagNames=['active','sup','sub']
            break
          default:
            this.showingTagNames=['active','sup','self']
            break
        }
        if(this.isTeacher)this.showingTagNames=['applying','apply']
        this.currentTagName=this.showingTagNames[0]

        this.tabChange()
        this.GET_STATISTICS()
      },
      methods:{
        addPlan(){
          sessionStorage.removeItem('planID')
          this.$root.$navName(this.mainRouteName+'.Appraisal.Publish',{add:true})
        },
        handleCardClk(data,btnItem){
          const rData={TYPE:data.TYPE,PFSNALTPLANID:data.PFSNALTPLANID,PFSNALTTRANSMITID:data.PFSNALTTRANSMITID}
          switch (btnItem.Type){
            case 'publish':
              this.$root.$navName(this.$route.name+'.Appraisal.Publish',rData)
              break
            default:
              this.$root.$navName(this.$route.name+'.Appraisal.Index',rData);
          }
        },
        doSearch(){
          this.searchData[this.currentTagName]=this.search
          this.getPlanList()
        },
        GET_STATISTICS(){
          const keys=['NOWYEAR','NOWCOUNT','ALLYEAR','ALLCOUNT']
          this.$store.dispatch(ActionType.GET_STATISTICS).then(res =>{
            keys.map((key,index)=>{
              this.summary[index]['count']=res[key]
            })
            this.tabSummary={active:res.ISPUBLICCOUNT,sup:res.TYPECOUNT2,sub:res.TYPECOUNT1,self:res.TYPECOUNT3,apply:res.TYPECOUNT1,applying:res.ISPUBLICCOUNT}
          })
        },
        initList(){
          const psList={Years:[{label:'全部',value:'all'}],'QUALIFICATIONS':[{label:'全部',value:'all'}],'SERIES':[{label:'全部',value:'all'}],'PFSNAME':[{label:'全部',value:'all'}],SUBJECT:[]},
              codeList=this.$store.getters.prtypeCodeList.code
          codeList.map(v=>{
            psList[v.LABEL].push({label:v.NAME,value:v.CODE})
          })
          const year=new Date().Format('yyyy')*1
          for(let i=2021;i<=year;i++){
            psList.Years.push({label:i,value:i})
          }
          this.options=psList
        },
        onScroll(e){
          if(!this.loadingData && this.planList[this.currentTagName].length<this.total[this.currentTagName])this.getPlanList(this.currentPage[this.currentTagName]+1)
        },
        //tab切换
        tabChange(com){
          console.log(this.currentTagName);
          // tagTitles:{'self':'自评评审','sub':'本级评审'-1,'sup':'上级评审'-2,'active':'进行中的评审'-4,'apply':'全部申报'-3,'applying':'进行中的申报'-4},
          this.search=this.searchData[this.currentTagName]||{}
          this.$level=this.levels[this.currentTagName]
          if(!this.planList.hasOwnProperty(this.currentTagName))this.getPlanList()
        },
        getPlanList(page=1){
          this.currentPage[this.currentTagName]=page
          let pData={CurrentPage:page,$level:this.$level}
          Object.keys(this.search).map(key=>{
            const v=this.search[key]
            if(v&&v!='all')pData[key]=v
          })
          this.loadingData=true
          this.$store.dispatch(ActionType.GET_PLAN_LIST,pData).then(res=>{
            this.total[this.currentTagName]=(res.count||0)*1
            /*for(let i=0;i<5;i++){
              res.list.push(res.list[0])
            }*/
            this.planList[this.currentTagName]=page==1?res.list:this.planList[this.currentTagName].concat(res.list)
            this.loadingData=false
            this.canGetMore=this.total[this.currentTagName]<=this.planList.length
          })
        },
      },
    }
